export default {"src":"/_next/static/media/Build.305f4da0.svg","height":32,"width":32};